import controller from './blocked.controller';
import '../student.less';

export default {
  controller,
  template: require('./blocked.html')
};



// WEBPACK FOOTER //
// src/app/components/student/blocked/blocked.component.ts